import React from 'react';
import { homePageTexts } from '@/assets/strings';
import Bubble from '@/components/Bubble';

const BubbleContainer: React.FC = () => {
  return (
    <div
      className={
        'flex justify-center items-center rounded-lg sm:max-w-full flex-col mx-auto'
      }
    >
      <div
        className={
          'flex justify-center items-center flex-col lg:flex-row gap-4 lg:gap-[4rem] xl:gap-[7rem] ml-0 md:ml-10'
        }
      >
        <Bubble
          order={'1'}
          header={homePageTexts.bubble1.header}
          text={homePageTexts.bubble1.text}
        />

        <Bubble
          order={'2'}
          header={homePageTexts.bubble2.header}
          text={homePageTexts.bubble2.text}
        />

        <Bubble
          order={'3'}
          header={homePageTexts.bubble3.header}
          text={homePageTexts.bubble3.text}
        />
      </div>
    </div>
  );
};

export default BubbleContainer;
